import type { RouteRecordRaw } from 'vue-router';

import { getCookie } from '@/api/user';

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    component: () => import('@/views/home/index.vue'),
    children: [
      {
        path: '',
        name: 'list',
        component: () => import('@/views/home/components/list/index.vue'),
      },
      {
        path: '/watchEdit/:id?',
        name: 'editor',
        component: () => import('@/views/home/components/edit/index.vue'),
      },
    ],
  },
];

export default routes;
